export default "__VITE_ASSET__Cy$H15JW__"